import AOS from 'aos';

window.onload  = () => {
  holderStyle.remove();

  setTimeout(() => {
    AOS.init();
  }, 500);
};
